import { createSlice } from "@reduxjs/toolkit";

const slice = createSlice({
  name: "user",
  initialState: {
    userInfo: {},
  },
  reducers: {
    setUserInfo(state, { payload }) {
      state.userInfo = payload;
    },
  },
});

export const { setUserInfo } = slice.actions;
export default slice.reducer;
